import { Flex, Text } from "@mantine/core";

import {
  AssessmentQuestionFieldBaseLabel,
  FIELD_CONFIG,
} from "../assessment-question-field";
import { AssessmentQuestionFields } from "@/types/screener-builder";

interface PostPublishFieldProps {
  content: string;
  field: AssessmentQuestionFields;
}

export const PostPublishField = ({ content, field }: PostPublishFieldProps) => {
  return (
    <Flex direction="column">
      <AssessmentQuestionFieldBaseLabel
        labelText={FIELD_CONFIG[field].labelText}
        helpLink={FIELD_CONFIG[field].helpLink}
        helpText={"Open help article"}
        withRequiredAsterisk={false}
      />
      <Text size="sm">{content}</Text>
    </Flex>
  );
};
